(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chimera-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chimera-back-to-top')) {
    customElements.define('chimera-back-to-top', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const update = () => {
          this.frame = null;
          this.button.hidden = window.scrollY < Math.max(500, window.innerHeight * 0.75);
        };
        const queue = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', queue, { passive: true, signal });
        window.addEventListener('resize', queue, { passive: true, signal });
        window.addEventListener('pageshow', queue, { signal });
        this.button.addEventListener('click', () => {
          // Put keyboard navigation back in the header before hiding this control.
          const topLink = document.querySelector('.header__heading-link') || document.querySelector('.skip-to-content-link');
          if (topLink) topLink.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chimera-floating-stickers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chimera-floating-stickers')) {
    customElements.define('chimera-floating-stickers', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.items = Array.from(this.querySelectorAll('.chimera-scroll-sticker'));
        this.toggle = this.querySelector('.chimera-sticker-toggle');
        this.main = document.getElementById('MainContent');
        if (!this.main || !this.toggle || !this.items.length) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.preference = this.readStorage('localStorage', 'chimera.stickers.visibility');
        this.disabled = this.preference ? this.preference === 'hidden' : this.motion.matches;
        this.mobileEnabled = this.dataset.mobileEnabled !== 'false';
        this.revealed = this.disabled;
        this.manual = new Map();
        this.placed = new Set();
        this.positions = this.createPositions();
        this.sequence = this.createSequence();
        this.queue = this.queue.bind(this);
        window.addEventListener('scroll', this.queue, { passive: true, signal: this.signal });
        document.addEventListener('scroll', this.queue, { passive: true, capture: true, signal: this.signal });
        window.addEventListener('resize', () => { this.placed.clear(); this.queue(); }, { passive: true, signal: this.signal });
        window.addEventListener('pageshow', this.queue, { signal: this.signal });
        document.addEventListener('toggle', this.queue, { capture: true, signal: this.signal });
        window.addEventListener('storage', (event) => {
          if (event.key !== 'chimera.stickers.visibility') return;
          this.preference = event.newValue;
          this.disabled = this.preference ? this.preference === 'hidden' : this.motion.matches;
          this.queue();
        }, { signal: this.signal });
        this.motion.addEventListener('change', () => {
          if (!this.preference) this.disabled = this.motion.matches;
          this.queue();
        }, { signal: this.signal });
        this.toggle.addEventListener('click', () => this.setDisabled(!this.disabled), { signal: this.signal });
        this.items.forEach((item, index) => {
          this.bindItem(item, index);
          item.querySelector('img').addEventListener('load', this.queue, { signal: this.signal });
          item.hidden = false;
        });
        this.resizeObserver = new ResizeObserver(this.queue);
        this.resizeObserver.observe(this.main);
        this.resizeObserver.observe(document.body);
        this.modalObserver = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.queue();
        });
        this.modalObserver.observe(document.body, {
          subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-expanded']
        });
        this.render();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.modalObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
      }
      readStorage(type, key) {
        try { return window[type].getItem(key); } catch { return null; }
      }
      writeStorage(type, key, value) {
        try { window[type].setItem(key, value); } catch {}
      }
      createSequence() {
        const order = this.items.map((item, index) => index);
        const randomize = this.dataset.randomize !== 'false';
        if (randomize) {
          for (let index = order.length - 1; index > 0; index--) {
            const swap = Math.floor(Math.random() * (index + 1));
            [order[index], order[swap]] = [order[swap], order[index]];
          }
          const previous = this.readStorage('sessionStorage', 'chimera.stickers.order');
          if (order.length > 1 && JSON.stringify(order) === previous) order.push(order.shift());
          this.writeStorage('sessionStorage', 'chimera.stickers.order', JSON.stringify(order));
        }
        const points = [0];
        for (let index = 0; index <= order.length; index++) {
          points.push(points[points.length - 1] + (randomize ? 0.7 + Math.random() * 0.6 : 1));
        }
        const overlap = Math.max(0.4, Math.min(0.9, (Number(this.dataset.presence) || 65) / 100));
        const sequence = [];
        order.forEach((index, position) => {
          const start = points[position];
          const next = points[position + 1];
          const linger = randomize ? Math.max(0.35, Math.min(0.95, overlap * (0.6 + Math.random() * 0.9))) : overlap;
          const end = next + (points[position + 2] - next) * linger;
          sequence[index] = {
            start,
            fadeIn: start + (next - start) * (randomize ? 0.22 + Math.random() * 0.16 : 0.3),
            fadeOut: next + (end - next) * (randomize ? 0.12 + Math.random() * 0.22 : 0.2),
            end
          };
        });
        const finish = sequence[order[order.length - 1]].end;
        sequence.forEach((timing) => {
          for (const key of ['start', 'fadeIn', 'fadeOut', 'end']) timing[key] /= finish;
        });
        return sequence;
      }
      opacityAt(index, progress) {
        const timing = this.sequence[index];
        if (progress <= timing.start || progress >= timing.end) return 0;
        const entering = (progress - timing.start) / (timing.fadeIn - timing.start);
        const leaving = (timing.end - progress) / (timing.end - timing.fadeOut);
        const amount = Math.max(0, Math.min(1, entering, leaving));
        return amount * amount * (3 - 2 * amount);
      }
      createPositions() {
        let previous = [];
        try { previous = JSON.parse(this.readStorage('sessionStorage', 'chimera.stickers.positions') || '[]'); } catch {}
        if (!Array.isArray(previous)) previous = [];
        const slots = this.positionSlots();
        const randomize = this.dataset.randomize !== 'false';
        const centerOffset = randomize ? Math.floor(Math.random() * 3) : 0;
        const used = new Set();
        const choices = this.items.map((item, index) => {
          const center = (index + centerOffset) % 3 === 1;
          const preferred = slots.filter((slot) => (slot % 5 > 0 && slot % 5 < 4) === center);
          let options = preferred.filter((slot) => !used.has(slot) && (!randomize || slot !== previous[index]));
          if (!options.length) options = slots.filter((slot) => !used.has(slot) && (!randomize || slot !== previous[index]));
          if (!options.length) options = slots.filter((slot) => !randomize || slot !== previous[index]);
          const slot = options[randomize ? Math.floor(Math.random() * options.length) : (index * 3) % options.length];
          used.add(slot);
          return slot;
        });
        this.writeStorage('sessionStorage', 'chimera.stickers.positions', JSON.stringify(choices));
        return choices.map((slot) => ({
          ...this.slotPosition(slot),
          inset: randomize ? Math.random() : 0.5,
          verticalOffset: randomize ? (Math.random() - 0.5) * 0.1 : 0
        }));
      }
      positionSlots() {
        return Array.from({ length: 20 }, (item, index) => index);
      }
      slotPosition(slot) {
        return { slot, horizontal: (slot % 5) / 4, vertical: 0.18 + Math.floor(slot / 5) * 0.2 };
      }
      viewport() {
        return { width: document.documentElement.clientWidth, height: window.innerHeight };
      }
      bounds(item) {
        const viewport = this.viewport();
        const size = item.getBoundingClientRect().width || (viewport.width < 750 ? 56 : 80);
        const edge = Math.min(parseFloat(getComputedStyle(this).getPropertyValue('--sticker-edge')) || 24, Math.max(8, (viewport.width - size) / 3));
        const header = document.querySelector('.section-header');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const top = Math.max(24, Math.min(viewport.height * 0.35, headerBottom + 16));
        return {
          left: edge,
          right: Math.max(edge, viewport.width - size - edge),
          top,
          bottom: Math.max(top, viewport.height - size - 140)
        };
      }
      place(item, index) {
        const bounds = this.bounds(item);
        const saved = this.manual.get(index);
        const position = this.positions[index];
        const span = Math.min(70, this.viewport().width * 0.035);
        const x = saved ? saved.x : bounds.left + (bounds.right - bounds.left) * position.horizontal + (position.inset - 0.5) * span;
        const y = saved ? saved.y : bounds.top + (bounds.bottom - bounds.top) * (position.vertical + position.verticalOffset);
        item.style.left = Math.max(bounds.left, Math.min(bounds.right, x)) + 'px';
        item.style.top = Math.max(bounds.top, Math.min(bounds.bottom, y)) + 'px';
      }
      textOverlaps(item) {
        const rect = item.getBoundingClientRect();
        return Array.from(document.querySelectorAll('h1, h2, h3, p, a, button, input, select, textarea, [class$="__description"]')).some((element) => {
          if (this.contains(element)) return false;
          const box = element.getBoundingClientRect();
          if (box.width < 4 || box.height < 4 || box.bottom < 0 || box.top > window.innerHeight) return false;
          const intersects = rect.left < box.right + 8 && rect.right > box.left - 8 && rect.top < box.bottom + 8 && rect.bottom > box.top - 8;
          if (!intersects) return false;
          const style = getComputedStyle(element);
          return style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
        });
      }
      chooseClearPosition(item, index) {
        const original = { ...this.positions[index] };
        const nearby = this.positionSlots().filter((slot) => slot !== original.slot);
        nearby.sort((left, right) => Math.abs(left % 5 - original.slot % 5) - Math.abs(right % 5 - original.slot % 5));
        const alternatives = [original.slot, ...nearby];
        for (const slot of alternatives) {
          this.positions[index] = { ...original, ...this.slotPosition(slot) };
          this.place(item, index);
          if (!this.textOverlaps(item) && !this.stickerOverlaps(item)) return;
        }
        this.positions[index] = original;
        this.place(item, index);
      }
      stickerOverlaps(item) {
        const rect = item.getBoundingClientRect();
        return this.items.some((other) => {
          if (other === item || !other.classList.contains('is-visible')) return false;
          const box = other.getBoundingClientRect();
          return rect.left < box.right + 16 && rect.right > box.left - 16 && rect.top < box.bottom + 16 && rect.bottom > box.top - 16;
        });
      }
      setOpacity(item, opacity) {
        const visible = opacity > 0;
        const interactive = opacity > 0.15;
        if (!interactive && document.activeElement === item) this.toggle.focus({ preventScroll: true });
        item.style.setProperty('--sticker-opacity', opacity.toFixed(3));
        item.classList.toggle('is-visible', visible);
        item.style.pointerEvents = interactive ? 'auto' : 'none';
        item.tabIndex = interactive ? 0 : -1;
        item.setAttribute('aria-hidden', String(!interactive));
      }
      queue() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.render();
        });
      }
      isModalOpen() {
        return !!document.querySelector('details.menu-opening, details[open] > .search-modal, cart-drawer.active, dialog[open], product-modal[open]');
      }
      render() {
        const viewport = this.viewport();
        const scroll = window.scrollY || document.documentElement.scrollTop;
        const start = Math.max(120, viewport.height * (Number(this.dataset.start) || 80) / 100);
        const end = document.documentElement.scrollHeight - viewport.height;
        const enoughRoom = end - start > 240;
        const available = enoughRoom && (viewport.width >= 750 || this.mobileEnabled);
        const blocked = this.isModalOpen();
        if (available && scroll >= start) this.revealed = true;
        const suppressed = !available || blocked || this.disabled;
        this.classList.toggle('is-suppressed', suppressed);
        const progress = enoughRoom ? (scroll - start) / (end - start) : -1;
        const dragging = this.drag && !suppressed;
        this.items.forEach((item, index) => {
          let opacity = suppressed ? 0 : this.opacityAt(index, progress);
          if (dragging && this.drag.index === index) opacity = 1;
          const image = item.querySelector('img');
          if (!suppressed && progress >= this.sequence[index].start - 0.08 && progress < this.sequence[index].end) {
            if (!image.hasAttribute('src')) image.src = image.dataset.gifSrc;
          }
          if (opacity > 0) {
            if (!this.placed.has(index) && !this.manual.has(index)) {
              this.chooseClearPosition(item, index);
              this.placed.add(index);
            }
            this.place(item, index);
            if (!this.manual.has(index) && (this.textOverlaps(item) || this.stickerOverlaps(item))) opacity = 0;
            if (!image.complete || !image.naturalWidth) opacity = 0;
          }
          this.setOpacity(item, opacity);
        });
        this.toggle.hidden = !available || blocked || !this.revealed;
        this.toggle.textContent = this.disabled ? this.dataset.showLabel : this.dataset.hideLabel;
        this.toggle.setAttribute('aria-pressed', String(!this.disabled));
      }
      setDisabled(disabled) {
        this.disabled = disabled;
        this.preference = disabled ? 'hidden' : 'shown';
        this.revealed = true;
        this.writeStorage('localStorage', 'chimera.stickers.visibility', this.preference);
        if (disabled && this.drag) this.endDrag(this.drag.item);
        this.render();
      }
      bindItem(item, index) {
        item.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          const rect = item.getBoundingClientRect();
          this.drag = { item, index, pointerId: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false };
          item.suppressClick = false;
          item.classList.add('is-dragging');
          item.setPointerCapture(event.pointerId);
        }, { signal: this.signal });
        item.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.item !== item || this.drag.pointerId !== event.pointerId) return;
          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          if (Math.hypot(dx, dy) > 4) this.drag.moved = true;
          if (!this.drag.moved) return;
          const bounds = this.bounds(item);
          this.manual.set(index, {
            x: Math.max(bounds.left, Math.min(bounds.right, this.drag.left + dx)),
            y: Math.max(bounds.top, Math.min(bounds.bottom, this.drag.top + dy))
          });
          this.place(item, index);
          event.preventDefault();
        }, { signal: this.signal });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((type) => {
          item.addEventListener(type, () => this.endDrag(item), { signal: this.signal });
        });
        item.addEventListener('click', () => {
          if (item.suppressClick) { item.suppressClick = false; return; }
          const position = this.positions[index];
          Object.assign(position, this.slotPosition((position.slot + 1) % this.positionSlots().length));
          this.manual.delete(index);
          this.chooseClearPosition(item, index);
        }, { signal: this.signal });
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.setDisabled(true);
            this.toggle.focus({ preventScroll: true });
            return;
          }
          const movement = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[event.key];
          if (!movement) return;
          event.preventDefault();
          const step = event.shiftKey ? 40 : 10;
          const rect = item.getBoundingClientRect();
          this.manual.set(index, { x: rect.left + movement[0] * step, y: rect.top + movement[1] * step });
          this.place(item, index);
        }, { signal: this.signal });
        item.addEventListener('dragstart', (event) => event.preventDefault(), { signal: this.signal });
      }
      endDrag(item) {
        if (!this.drag || this.drag.item !== item) return;
        const drag = this.drag;
        this.drag = null;
        item.suppressClick = drag.moved;
        item.classList.remove('is-dragging');
        if (item.hasPointerCapture(drag.pointerId)) item.releasePointerCapture(drag.pointerId);
        this.queue();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chimera-gift-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chimera-gift-note')) {
    customElements.define('chimera-gift-note', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.form = this.closest('form');
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.fields = this.querySelector('[data-gift-fields]');
        this.nameInput = this.querySelector('[data-gift-name]');
        this.error = this.querySelector('[data-gift-error]');
        if (!this.form || !this.toggle || !this.nameInput) return;

        this.toggle.addEventListener('change', () => {
          this.attempted = false;
          this.sync();
        }, { signal });
        this.nameInput.addEventListener('input', () => this.sync(), { signal });
        this.nameInput.addEventListener('change', () => {
          this.nameInput.value = this.nameInput.value.trim();
          this.sync();
        }, { signal });
        this.form.addEventListener('submit', (event) => {
          this.nameInput.value = this.nameInput.value.trim();
          if (this.sync()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.attempted = true;
          this.sync();
          this.nameInput.focus();
          this.nameInput.reportValidity();
        }, { capture: true, signal });
        this.form.addEventListener('reset', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.attempted = false;
            this.sync();
          });
        }, { signal });
        this.sync();
        this.hidden = false;
      }

      sync() {
        const selected = this.toggle.checked;
        const valid = !selected || this.nameInput.value.trim().length > 0;
        this.fields.hidden = !selected;
        this.nameInput.disabled = !selected;
        this.nameInput.required = selected;
        this.nameInput.setCustomValidity(valid ? '' : this.nameInput.dataset.error);
        this.error.hidden = valid || !this.attempted;
        this.nameInput.setAttribute('aria-invalid', String(!valid && Boolean(this.attempted)));
        const checkout = this.form.querySelector('[data-chimera-dynamic-checkout]');
        if (checkout) checkout.hidden = !valid;
        return valid;
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
